import { Analytics } from '../helpers/analytics';
import {ElementHelpers} from '../helpers/element-helpers';

export class Video {

	constructor(elem) {
		this.elem = elem;

		this.image = this.elem.querySelector('.video__image');
		this.closebutton = this.elem.querySelector('.video__closebutton');
		this.wrapper = this.elem.querySelector('.video__wrapper');

		this.videoHolder = this.elem.querySelector('[data-videoid]');
		this.videoid = this.videoHolder.dataset.videoid || '';
		this.parameters = this.videoHolder.dataset.videoParameters || '';

		this.draggableParent = ElementHelpers.getParentByClass(this.elem, 'draggable__track');

		this.sent = {
			first: false,
			second: false,
			third: false,
			fourth: false
		};

		this.videoStarted = false;

		this.addEventHandlers();

		Video.initAPI();

	}

	/**
	 * parse the parameter string and return it as object
	 *
	 * @type {Object}
	 */
	get videoParameters() {
		const paramList = this.parameters.split(','),
			obj = {};

		for (let i = 0; i < paramList.length; i++) {
			obj[paramList[i].split(':')[0]] = paramList[i].split(':')[1];
		}

		return obj;
	}

	static getSelector() {
		return '[data-video]';
	}

	/**
	 * Initialize the Youtube API
	 *
	 * @returns {void}
	 * @static
	 */
	static initAPI() {
		if (document.getElementById('youtubeScript') === null) {
			const tag = document.createElement('script');
			tag.src = '//www.youtube.com/iframe_api';
			tag.id = 'youtubeScript';

			const firstScriptTag = document.getElementsByTagName('script')[0];
			firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
		}
	}

	/**
	 * Add the event listener to the play button
	 *
	 * @returns {void}
	 */
	addEventHandlers() {
		this.image.addEventListener('click', () => {
			if (!this.videoStarted){
				this.loadVideo();
			}else{
				this.openVideo();
			}
		});
		this.closebutton.addEventListener('click', () => {
			this.closeVideo();
		});
		this.wrapper.addEventListener('click', () => {
			this.closeVideo();
		});
		document.onkeydown = (evt) => {
			evt = evt || window.event;
			if (evt.keyCode == 27 && this.wrapper.classList.contains('modal--open')) {
				this.closeVideo();
			}
		};
	}

	/**
	 * load the video with the youtube api
	 *
	 * @returns {void}
	 */
	loadVideo() {
		this.video = new YT.Player(this.videoHolder.id || this.videoid, {
			height: '100%',
			width: '100%',
			videoId: this.videoid,
			playerVars: this.videoParameters,
			events: {
				'onReady': (e) => {
					this.onVideoReady(e);
				},
				'onStateChange': (e) => {
					this.onStateChange(e);
				}
			}
		});
		document.body.classList.add('overflow-hidden');
		document.getElementsByTagName('html')[0].classList.add('overflow-hidden');
		this.wrapper.classList.add('modal--open');
		this.handleIosIssue('add');
	}

	/**
	 * Prevent iOS bug when opening video in multiple video component
	 * @param func
	 */
	handleIosIssue(func) {
		if (this.draggableParent) {
			if (func === 'add') {
				this.draggableParent.classList.add('video--open');
			} else {
				this.draggableParent.classList.remove('video--open');
			}
		}
	}

	onVideoReady() {
		this.videoStarted = true;
		this.elem.classList.add('video--playing');

		this.duration = this.video.getDuration(); //get video duration

		//check status
		setInterval(() => {
			this.checkPlayer();
		}, 1000);
	}

	/**
	 * log the events that are coming from youtube
	 *
	 * @returns {void}
	 */
	onStateChange(e) {
		switch (e.data) {
			case YT.PlayerState.PLAYING:
				this.logEvent('play');
				break;
			case YT.PlayerState.PAUSED:
				this.logEvent('pause');
				break;
			case YT.PlayerState.ENDED:
				this.logEvent('finish');
				break;
		}
	}

	logEvent(action) {
		Analytics.measure({
			action: action,
			label: this.videoid,
			category: 'video'
		});
	}

	openVideo() {
		this.wrapper.classList.add('modal--open');
		document.body.classList.add('overflow-hidden');
		document.getElementsByTagName('html')[0].classList.add('overflow-hidden');
		this.handleIosIssue('add');
		this.video.playVideo();
	}

	closeVideo() {
		this.wrapper.classList.remove('modal--open');
		document.body.classList.remove('overflow-hidden');
		document.getElementsByTagName('html')[0].classList.remove('overflow-hidden');
		this.handleIosIssue('remove');
		this.video.pauseVideo();
		this.onplayerReset();
	}

	checkPlayer() {
		let ytp = this.video.getCurrentTime();
		let duration = this.duration;
		let calculate = ytp / duration * 100;
		calculate = Math.round(calculate);

		if (ytp.isReset) {
			calculate = 0;
		}

		this.video.calculate = calculate;

		if (!ytp.completed) {

			let r42Track = (percentage) => {

				if (typeof _st !== 'undefined' && _st.event) {
					//declare r42 event function
					_st.event.publish('_trackEvent', 'video', {     //send relay event
						'category': 'video_progress',
						'action': this.video.getVideoEmbedCode(),
						'label': percentage
					});
				}

			};

			const triggerTracking = (percentage, sentItem) => {
				if (!this.sent[sentItem]) {
					r42Track(percentage);
					this.sent[sentItem] = true;
				}
			};

			this.calculatePercentage(calculate, triggerTracking);
		}
	}

	calculatePercentage(calculate, triggerTracking) {
		if (calculate >= 25 && calculate < 50) {
			triggerTracking('25%', 'first');
		}

		if (calculate >= 50 && calculate < 75) {
			triggerTracking('50%', 'second');
		}

		if (calculate >= 75 && calculate < 100) {
			triggerTracking('75%', 'third');
		}

		if (calculate === 100) {
			triggerTracking('100%', 'fourth');
			this.onplayerReset();
		}
	}

	onplayerReset() {
		clearInterval();
	}

}

